import { axiosInstance } from '../../utils';
import { BrollCaptionVideo } from '../../@types';
import { useMutation } from '@tanstack/react-query';

interface Payload {
  id: string;
  name: string;
}

export const updateBrollVideoName = async (payload: Payload): Promise<BrollCaptionVideo> => {
  const res = await axiosInstance.put(`/api/video/update-name`, payload);
  return res.data;
};

export function useUpdateBrollVideoName() {
  return useMutation(updateBrollVideoName, { onSuccess: (data) => data });
}
